const translations = {
    'buildings.actions': 'Actions',
    'buildings.label.blacksmith': 'Blacksmith',
    'buildings.label.barracks': 'Barracks',
    'buildings.label.caravanPost': 'Caravan post',
    'buildings.label.charcoalPit': 'Charcoal pit',
    'buildings.label.farm': 'Farm',
    'buildings.label.fishingHut': 'Fishing hut',
    'buildings.label.goldMine': 'Gold mine',
    'buildings.label.house': 'House',
    'buildings.label.stoneHouse': 'Stone house',
    'buildings.label.huntingHut': 'Hunting hut',
    'buildings.label.ironMine': 'Iron mine',
    'buildings.label.lumberjackCamp': 'Lumberjack camp',
    'buildings.label.masonry': 'Masonry',
    'buildings.label.mint': 'Mint',
    'buildings.label.stable': 'Stable',
    'buildings.label.quarry': 'Quarry',
    'buildings.label.sawmill': 'Sawmill',
    'buildings.label.smelter': 'Smelter',
    'buildings.label.smokehouse': 'Smokehouse',
    'buildings.label.weaver': 'Weaver',
    'buildings.list.blacksmith': '- Blacksmiths: %d',
    'buildings.list.caravanPost': '- Caravan posts: %d',
    'buildings.list.charcoalPit': '- Charcoal pit: %d',
    'buildings.list.farm': '- Farms: %d',
    'buildings.list.fishingHut': '- Fishing huts: %d',
    'buildings.list.goldMine': '- Gold mines: %d',
    'buildings.list.houses': '- Houses: %d',
    'buildings.list.stoneHouses': '- Stone houses: %d',
    'buildings.list.huntingHut': '- Hunting huts: %d',
    'buildings.list.ironMine': '- Iron mine: %d',
    'buildings.list.lumberjack': '- Lumberjack camp: %d',
    'buildings.list.masonry': '- Masonry: %d',
    'buildings.list.mint': '- Mints: %d',
    'buildings.list.quarry': '- Quarry: %d',
    'buildings.list.sawmill': '- Sawmill: %d',
    'buildings.list.smelter': '- Smelter: %d',
    'buildings.list.smokehouse': '- Smokehouses: %d',
    'buildings.list.storage': '- Storage',
    'buildings.list.stable': '- Stables: %d',
    'buildings.list.weaver': '- Weavers: %d',
    'buildings.region': 'Region resources',
    'buildings.section': 'Buildings',
    'buildings.slots': 'Slots: %d/%d',
    'buildings.storage': 'Storage',
    'construction.none': 'No construction queued',
    'construction.section': 'Construction',
    'nature.section': 'Region resources',
    'region.fish': 'fish %d',
    'region.gold': 'gold %d',
    'region.goldDeposit': 'gold deposit %d',
    'region.ironDeposit': 'iron deposit %d',
    'region.stone': 'stone %d',
    'region.stoneDeposit': 'stone deposit %d',
    'region.trees': 'trees %d',
    'region.wildlife': 'wildlife %d',
    'storage.line1': 'food %d • tools %d',
    'storage.line2': 'planks %d • wood %d',
};

export default translations;
